export class UtilsEnum {

    public static combineEnums(enum1: any, enum2: any): any {
        let result: any = enum1;
        result |= enum2;

        return result;
    }

    public static removeEnum(enum1: any, enumToRemove: any): any {
        let result: any = enum1;
        result &= ~enumToRemove;

        return result;
    }

    public static checkEnum(value: any, enumToCheck: any): boolean {
        return (enumToCheck === (value & enumToCheck));
    }

}
